var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://dashboard.tawk.to/login","width":"100%","height":"1080px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }